export const dashboardUsers = [
	{
		id: 1000, name: 'Vanko Antonov', projects: [901, 103, 118]
	},
	{
		id: 1001, name: 'Juan Battle', projects: [903, 902, 115, 119, 120, 120]
	},
	{
		id: 1002, name: 'Megan Cott', projects: [121, 122, 112]
	},
	{
		id: 1003, name: 'Julie Bond', projects: [901, 903, 113, 109]
	},
	{
		id: 1004, name: 'Omkar Dokur', projects: [103, 118, 123, 117]
	},
	{
		id: 1005, name: 'Lucy Deba Enomah', projects: [902, 105, 107, 118, 115]
	},
	{
		id: 1006, name: 'Dennis Hinebaugh', projects: [110, 121]
	},
	{
		id: 1007, name: 'Jason Jackman', projects: [902, 105, 106]
	},
	{
		id: 1008, name: 'Chanyoung Lee Ph.D.', projects: [111, 116, 119, 108]
	},
	{
		id: 1009, name: 'Stephanie Lewis', projects: [903, 102, 114, 119]
	},
	{
		id: 1010, name: 'Dr. Fred L. Mannering', projects: [103, 118, 117, 122]
	},
	{
		id: 1011, name: 'Nikhil Menon Ph.D.', projects: [901, 902, 105, 109, 113]
	},
	{
		id: 1012, name: 'Lori Palaio', projects: [903, 102, 121, 120, 111]
	},
	{
		id: 1013, name: 'Tyler Roessler', projects: [109, 111, 120, 121]
	},
	{
		id: 1014, name: 'Mark Mistretta', projects: [101, 102, 121, 120, 111]
	}
];

export const dashboardProjects = [
	{
		"id": 901,
		"name": "New Project 1",
		"status": 0,
		"desc_text": "Lorem ipsum dolor sit amet, vix ea blandit suavitate incorrupte, petentium necessitatibus vis te, eu cetero aperiam reformidans usu. Ne moderatius assueverit scripserit mei. Mel ei veri nusquam, quo at diceret elaboraret. Eius mutat facete at duo."
	},
	{
		"id": 902,
		"name": "New Project 2",
		"status": 0,
		"desc_text": "Aperiam sententiae id qui, nec prodesset disputationi ut, quo ea justo iriure. Choro temporibus an vim. Te usu iudicabit hendrerit liberavisse, ea errem simul est, ne legere vivendo reprehendunt vis. Te eius antiopam consectetuer mea, vix ad debet euripidis interpretaris. Ei tation urbanitas constituam vel, purto eros prompta et sed."
	},
	{
		"id": 903,
		"name": "New Project 3",
		"status": 0,
		"desc_text": "Cu omnium indoctum complectitur mel, ex vel sint quodsi lobortis, te esse moderatius definiebas sea. Eum vidit facilisi et. In vim doctus tacimates corrumpit, no sea assentior constituto, vis et magna luptatum. At posse aliquip vel. Malis scriptorem persequeris mei ut, sententiae voluptatibus vel ex."
	},
	{
		"id": 101,
		"name": "Central Florida Autonomous Vehicle Proving Ground",
		"status": 1,
		"category": "a;c;e",
		"district": "5",
		"mode": "a;t",
		"geom": "1",
		"people": "1;2",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/CF_AV_Map.png",
		"desc_text": "The Central Florida Automated Vehicle Partnership applied for and was approved by the United States Department of Transportation as a proving ground to become one of the nation’s premiere cluster for research and development of automated vehicle technology across all modes of travel. The City of Orlando led the effort in partnership with FDOT, Central Florida Expressway Authority, University of Central Florida, Florida Polytechnic University, Florida A&M University, Florida State University, Lynx, and NASA.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 102,
		"name": "Connected Freight Priority System Deployment",
		"status": 1,
		"category": "c",
		"district": "4",
		"mode": "a",
		"geom": "1",
		"people": "3",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/westernend.png?sfvrsn=84c688d4_2",
		"desc_text": "The scope of work includes deployment of a combination of Vehicle to Infrastructure (V2I) and Vehicle to Vehicle (V2V) components required for the freight vehicles. The project will integrate number of safety and mobility applications including freight signal priority. The project will include OBUs communicating to the RSUs to be installed at strategic locations along the project routes and traffic signals on SR 710. The project routes are consisting of a combination of rural and urban segments between SR 706 (Indiantown Rd) and the Port of Palm Beach in Palm Beach County.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 103,
		"name": "US 1 Keys COAST",
		"status": 1,
		"category": "c",
		"district": "6",
		"mode": "a;t",
		"geom": "1",
		"people": "4",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/images/us-keys.png?sfvrsn=c6847e72_0",
		"desc_text": "Major project features include but are not limited to:112.5 miles; Key West to Key Largo; sole access and evacuation route for the Florida Keys50 signals/devices, several transit routes, freight corridorPedestrian and cyclist safety, V2V, drawbridge management, emergency vehicle preemption (EVP), freight signal priority (FSP), transit signal priority (TSP), weigh-in-motion (WIM)Real-time data exchangeDedicated short range communication and cellularSignals are operated and maintained by District 6; Monroe County and Key West have opted out of the Traffic Signal Maintenance and Compensation Agreement (TSMCA)",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 104,
		"name": "US 98 Smart Bay",
		"status": 1,
		"category": "c;s",
		"district": "3",
		"mode": "a;t",
		"geom": "1",
		"people": "5",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/smart-bay.png?sfvrsn=1ad90a18_3",
		"desc_text": "Bay County is a popular destination for vacationers while it is going through new construction at the beach, and a lot of re-construction along with proposed industrial park and a retirement community. Panama City Beach has many special events around the year that attracts about 17 million visitors each year. Smart Bay CAV covers approximately 51 miles of US 98 as shown in the figure. Smart Bay is aimed at making visitor’s experience memorable and increasing economic vitality of the region by improving safety and mobility, and increasing economic development activities in the region.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 105,
		"name": "Downtown Tampa Autonomous Transit",
		"status": 2,
		"category": "a",
		"district": "7",
		"mode": "t",
		"geom": "1",
		"people": "9",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/images/tampa.png?sfvrsn=6eadbaa_0",
		"desc_text": "Marion Street is a north and south running roadway in the center of downtown Tampa. Between the hours of 6am and 7pm on weekdays, the corridor is for exclusive use of buses and emergency vehicles, and therefore offers an opportunity to operate a low-speed, autonomous last-mile shuttle service out of mixed traffic. The service would address mobility needs downtown by connecting the Marion Transit Center and parking to employment, and act as a catalyst for further autonomy in transportation throughout the Tampa Bay region.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 106,
		"name": "Florida's Turnpike Enterprise (FTE) SunTrax",
		"status": 2,
		"category": "c;e;s;a",
		"district": "t",
		"mode": "a;t",
		"geom": "1",
		"people": "10",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/images/suntrax_cd_wip_cam01.jpg?sfvrsn=77a4508d_2",
		"desc_text": "SunTrax is situated on 475 acres and is composed of a 2.25-mile-long oval test track around a 200-acre infield. The multi-lane track will make it the only high-speed autonomous vehicle (AV) testing facility in the southeastern United States. In the infield, there will be multiple simulated transportation environments, including:An urban area to simulate intersection configurations and complex lighting, signing, and signalization conditionsA 20-acre open paved technology pad providing the ability to replicate nearly any real-world geometric configuration and perform endless test scenariosA roadway geometry track made up of complex horizontal and vertical curves, plus irregular grade changesA pick-up/drop-off area to replicate various multi-modal passenger transfers, such as airports and transit centersThe intent is to maximize the site’s flexibility and variability, providing as many challenging environments as possible for the testing of connected and autonomous vehicles (CAV) and other emerging technologies. The entire site will be a connected environment for the testing of vehicle-to-infrastructure (V2I), vehicle-to-vehicle (V2V), and vehicle-to-anything (V2X) communications. SunTrax will also have a unique tolls technology testing component, with four all-electronic toll gantries and supporting infrastructure being constructed. FTE will conduct its tolls testing on the site, both on existing hardware and software systems and future generations of tolling equipment and payment systems.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 107,
		"name": "Gainesville Bike and Pedestrian Safety",
		"status": 2,
		"category": "c;s",
		"district": "2",
		"mode": "b",
		"geom": "1",
		"people": "7",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/gainesville-ped-bike-cv-safety-updated-map.png?sfvrsn=45d815e6_2",
		"desc_text": "FDOT applied for the Federal Accelerated Innovation Deployment (AID) program in April 2017 to test and implement connected vehicle and pedestrian/bicyclist safety applications (active or passive) at 13 signalized intersections and 12 mid-block crossings within the core of the University of Florida (UF) campus. The goal of this project is to reduce pedestrian and bicycle crashes and conflicts with vehicles and transit. The routes are SR 26 (University Avenue), US 441 (SW 13th Street), Museum Road, and Gale Lemerand Drive. The project will install roadside units (RSUs), passive pedestrian detection systems, on-board units, and rectangular rapid flashing beacons.  The project will consist of before and after analysis led by UF.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 108,
		"name": "I-4 Florida's Regional Advanced Mobility Elements (FRAMES)",
		"status": 2,
		"category": "c",
		"district": "7",
		"mode": "a;t",
		"geom": "1",
		"people": "11",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/i-4-geoarea_updated07292019.png?sfvrsn=be1fbef7_4",
		"desc_text": "Interstate 4 (I-4) Florida’s Regional Advanced Mobility Elements (FRAME) is a regional, intercity integrated corridor management (ICM) project running from the Central Business District in Tampa to the southwest side of Orlando at the Florida Turnpike. I-4 and the other ICM routes cross four (4) counties: Hillsborough, Polk, Osceola, and Orange. Please see Figure 1 for a map of the I-4 FRAME ICM routes. I-4 FRAME will cover 77 miles of I-4, 122 miles of other limited-access routes, and signalized arterial roadways with a total of 491 traffic signal systems.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	},
	{
		"id": 109,
		"name": "I-75 Florida's Regional Advanced Mobility Elements (FRAMES) Gainesville",
		"status": 2,
		"category": "c",
		"district": "2",
		"mode": "a;t",
		"geom": "1",
		"people": "12",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/I75Map.jpg",
		"desc_text": "This I-75 Florida's Regional Advanced Mobility Elements (FRAME) project will deploy emerging technologies to better manage, operate, and maintain the multi-modal transportation system and create an Integrated Corridor Management solution on I-75 and state highway systems in the Cities of Gainesville and Ocala. The emerging technologies proposed in this project are Automated Traffic Signal Performance Measures and Connected Vehicle technologies such as Roadside Units and On Board Units for effective traffic operations; Transit Signal Priority and Freight Signal Priority. The goal of the project is to disseminate real-time information to the motorists during freeway incidents.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 110,
		"name": "I-75 Florida's Regional Advanced Mobility Elements (FRAMES) Ocala",
		"status": 2,
		"category": "c",
		"district": "5",
		"mode": "a;t",
		"geom": "1",
		"people": "13",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/I75Map.jpg",
		"desc_text": "This I-75 Florida's Regional Advanced Mobility Elements (FRAME) project will deploy emerging technologies to better manage, operate, and maintain the multi-modal transportation system and create an Integrated Corridor Management solution on I-75 and state highway systems in the Cities of Gainesville and Ocala. The emerging technologies proposed in this project are Automated Traffic Signal Performance Measures and Connected Vehicle technologies such as Roadside Units and On Board Units for effective traffic operations; Transit Signal Priority and Freight Signal Priority. The goal of the project is to disseminate real-time information to the motorists during freeway incidents.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 111,
		"name": "Implementing Solutions from Transportation Research and Evaluation of Emerging Technologies (I-STREET)",
		"status": 2,
		"category": "c;e;s;a",
		"district": "2",
		"mode": "a;t",
		"geom": "1",
		"people": "14",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/updated-i-street-map_1-2-2020.png?sfvrsn=5c7fd598_2",
		"desc_text": "The University of Florida (UF) Implementing Solutions from Transportation Research and Evaluation of Emerging Technologies (I-STREET) Test Bed is a collaboration of UF, FDOT, and the City of Gainesville. The intent of the UF I-STREET Test Bed is to invite industry partners, private sector developers, research entities, and transportation innovators of emerging technologies and transportation solutions to express implementation interest and provide deployment-oriented approaches in the pursuit of solutions for real-world test bed demonstration and testing. The anticipated outcome of assisting the UF I-STREET partners is to transition from development to a realization of transportation safety and mobility benefits as quickly as possible. The UF I-STREET will leverage several ongoing efforts at FDOT, including the use of hardware and software solutions being deployed to realize the benefits from connected vehicle technologies to improve the safety and mobility of road users. This initiative plans to provide UF I-STREET partners with data and other outputs to be sourced from the ongoing projects at FDOT.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 112,
		"name": "Lake Mary Boulevard CV Project",
		"status": 2,
		"category": "c;s;a",
		"district": "5",
		"mode": "t",
		"geom": "1",
		"people": "15",
		"desc_photo": "images/lakemary.png",
		"desc_text": "The Lake Mary Boulevard CV project will deploy and test connected vehicle technology and applications along seven signalized intersections from International Parkway to Rinehart Road in Lake Mary, Florida. The CV applications that will be evaluated include Red Light Violation Warning, Signal Phase and Timing, Forward Collision Warning, Target Classification (identifying other OBUs), and Traffic Incident Message. The project will be completed by Spring 2020.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 113,
		"name": "Orlando Smart Community (2017 ATCMTD)",
		"status": 2,
		"category": "a;c;s",
		"district": "5",
		"mode": "a;t;b",
		"geom": "",
		"people": "1",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/atcmtd/SmartCom2.png",
		"desc_text": "The Florida Department of Transportation, in partnership with MetroPlan Orlando, the University of Central Florida, the City of Orlando, and Orange County are pleased to announce the receipt of the Advanced Transportation and Congestion Management Technologies Deployment (ATCMTD) grant for the Connecting the East Orlando Communities project. Connecting the East Orlando Communities represents the Central Florida Automated Vehicle Partners Smart Cities approach consisting of three program areas: PedSafe, GreenWay, and Smart Community.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 114,
		"name": "Pinellas County Signal Phase and Timing (SPaT)",
		"status": 2,
		"category": "c",
		"district": "7",
		"mode": "a;t",
		"geom": "1",
		"people": "11",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/images/pinellas-county-spat.png?sfvrsn=5d973fd4_1",
		"desc_text": "FDOT, in partnership with Pinellas County, plans to deploy a Signal Phase and Timing (SPaT) project at 23 traffic signals along a portion of US 19 corridor. 11 traffic signals are at-grade intersections on US 19 and 12 signals are along frontage roads. This project will add to two other FDOT initiatives with the AASHTO SPaT Challenge: Tallahassee US 90 and Gainesville Trapezium.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 115,
		"name": "SR 434 Connected Vehicle Deployment",
		"status": 2,
		"category": "c;a;e",
		"district": "5",
		"mode": "a",
		"geom": "1",
		"people": "13",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/images/sr434map.png?sfvrsn=ddab3f87_2",
		"desc_text": "FDOT District 5 is in the implementation phase of a Connected Vehicle(CV) project on SR 434 from McCulloch Road to E Mitchell Hammock Road. The purpose of this project is to implement CV technology and Signal Performance Metrics (SPM) in Seminole County. The project will deploy Roadside Units(RSU) and utilize Signal Phasing and Timing, Transit Signal Priority, and preemption applications along SR 434. SPM data shall be captured through a retrofit technology. Approximately six RSUs are installed in this project. The project is anticipated to complete deployment by 2020.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 116,
		"name": "US 41 Florida's Regional Advanced Mobility Elements (FRAMES)",
		"status": 2,
		"category": "c",
		"district": "1",
		"mode": "a;t",
		"geom": "1",
		"people": "",
		"desc_photo": "https://fdotwww.blob.core.windows.net/sitefinity/images/default-source/content1/traffic/its/projects_deploy/cv/images/us-41.png?sfvrsn=c46ceb01_0",
		"desc_text": "The purpose of the US 41 FRAME project is to deploy emerging safety and mobility solutions for US 41 Arterial FRAME such as Automated Traffic Signal Performance Measures (ATSPM) and Connected and Automated Vehicles (CAV) solutions.  The goal is to improve safety and mobility of the corridor.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 117,
		"name": "Gainesville AV Shuttle",
		"status": 4,
		"category": "c;e",
		"district": "2",
		"mode": "t",
		"geom": "1",
		"people": "16",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/GatricMap1.png",
		"desc_text": "This project will deploy an autonomous transit system to connect the City of Gainesville Innovation District and downtown with the University of Florida campus and student housing by means of frequent transit service. The goal of the Gainesville Autonomous Transit Shuttle (AV) is to maintain a maximum headway of 10 minutes or less for the buses. AV routes include SW 4th Avenue, SW 13th Street, SW 2nd Avenue, and S Main Street. The project is anticipated to complete deployment by late 2018.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 118,
		"name": "AV Shuttles at Lake Nona",
		"status": 4,
		"category": "e;c",
		"district": "5",
		"mode": "t",
		"geom": "1",
		"people": "6",
		"desc_photo": "images/lakenona.png",
		"desc_text": "Two autonomous vehicle (AV) shuttles operate in Lake Nona, Florida. The AV shuttles transport residents, workers, and visitors along Tavistock Lake Boulevard from behind the Pixon Apartments outside the Lake Nona Town Center to Canvas Restaurant and Market in the Village Center. The route is 1.2 miles, and a shuttle arrives every 10 to 15 minutes. The shuttles began operation on September 18, 2019",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 119,
		"name": "Gainesville Signal Phase and Timing (SPaT) Trapezium",
		"status": 4,
		"category": "c",
		"district": "2",
		"mode": "a;t",
		"geom": "1",
		"people": "7",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/Gains_Trapezium_Map.png",
		"desc_text": "This project is deployed with connected vehicle (CV) technologies and applications along four roads forming a trapezium surrounding the University of Florida main campus. The routes are SR 121 (SW 34th St), SR 26 (W University Ave), US 441 (SW 13th St), and SR 24 (SW Archer Rd). The goal of the project is to improve travel time reliability, safety, throughput, and traveler information. This project will also deploy and test pedestrian and bicyclist safety CV and smartphone-based applications. The project covers 27 traffic signals equipped with 27 Roadside Units. The project became operational in September 2019.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 120,
		"name": "Osceola County Connected Vehicle Signals",
		"status": 4,
		"category": "c;a;e",
		"district": "5",
		"mode": "a;t",
		"geom": "1",
		"people": "7",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/OsceolaMap.png",
		"desc_text": "Osceola County is pushing connected vehicle (CV) technology forward by deploying Roadside Units (RSU) at two signalized intersections. The deployment was sponsored by the Federal Highway Administration as a pilot project to test Dedicated Short Range Communications equipment and intersection processing equipment to gain experience and compile lessons learned in the deployment of CV infrastructure and applications. The RSUs were deployed at the intersection of Osceola Parkway and Orange Blossom Trail, and the intersection of Orange Blossom Trail and Poinciana. The Poinciana intersection had a mast arm, while the Osceola Parkway intersection had a span wire.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 121,
		"name": "Tampa Hillsborough Expressway Authority (THEA) Connected Vehicle Pilot",
		"status": 4,
		"category": "e;c;a",
		"district": "7",
		"mode": "t",
		"geom": "1",
		"people": "8",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/THEA_CVP_Map.png",
		"desc_text": "The Tampa Connected Vehicle (CV) Pilot Program, one of only three such programs, was awarded through a national competition by the United States Department of Transportation. This program, led by the Tampa-Hillsborough Expressway Authority, is now in the design and deployment phase, with deployment beginning in 2018. The Tampa CV Pilot Program includes various CV applications in and around downtown Tampa. The applications focus on safety and mobility for multiple modes of travel, including streetcars, buses, passenger cars, and pedestrians.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 122,
		"name": "US 90 Signal Phase and Timing (SPaT) Tallahassee",
		"status": 4,
		"category": "c",
		"district": "3",
		"mode": "a;t",
		"geom": "1",
		"people": "7",
		"desc_photo": "https://www.fdot.gov/images/default-source/content-images/traffic/its/projects_deploy/cv/images/US90_Map.png",
		"desc_text": "Under FDOT’s TSM&O Program, arterial traffic management solutions are receiving renewed focus, especially given the technology advances offered by connected vehicles (CV). Case in point is a major Signal Phase and Timing (SPaT) project using CV technology underway at the City of Tallahassee.The testing and implementation of SPaT at select intersections around Florida will support the advancement of Vehicle-to-Infrastructure capabilities, especially related to intersection safety applications. It will also give FDOT and local agency staff the opportunity to gain experience in the operation and maintenance of CV infrastructure and applications.",
		"desc_video": "",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}, {
		"id": 123,
		"name": "Voyage at The Villages",
		"status": 4,
		"category": "a;s;c",
		"district": "5",
		"mode": "a;t",
		"geom": "1",
		"people": "",
		"desc_photo": "images/villages.jpg",
		"desc_text": "The Villages is massive. Spread over 750 miles of road and 40 square miles of land in Central Florida, the U.S. Census ranked The Villages as the fastest-growing U.S. city for a second year in a row in 2014. Its population is larger than 31 of the 67 counties in Florida. We’re bringing a door-to-door self-driving taxi service to the The Villages. When fully operational, all 125,000 residents will have the ability to summon a self-driving car to their doorstep using the Voyage mobile app, then travel autonomously anywhere within the community.",
		"desc_video": "https://voyage.auto/images/vgfl-hero-2.mp4",
		"sponsors": "",
		"partners": "",
		"keywords": "",
		"start_date": "",
		"end_date": "",
		"funding": "",
		"last_updated": "",
		"data": "",
		"metrics": ""
	}
];